/**
 * Handles errors in a priority and also in a lazy way.
 * Priorities depend on:
 * - scope.viewMngr.getPrioritizedErrors()
 *
 * Laziness means that errors won't be displayed until following condition happens:
 * - scope.getAdditionalErrorsDisplayCondition()
 */

(function () {
    'use strict';

    angular
        .module('repairforms.directive.module')
        .directive("lazyErrorHandling", LazyErrorHandling);

    function LazyErrorHandling() {

        return {
            scope: true,
            require: 'ngModel',
            link: function (scope, el, attr, ngModelCtrl) {
                function fromUser(text) {
                    var priorities = scope.viewMngr.getPrioritizedErrors();
                    var showCondition = scope.getAdditionalErrorsDisplayCondition();
                    var inputErrors = ngModelCtrl.$error;
                    var inputName = angular.element(el).attr('name');
                    var isMsgSet = false;

                    priorities.forEach(function(elem) {
                        if(inputErrors[elem] && !isMsgSet && showCondition) {
                            angular.element('[error-for = ' + elem + '][paired-input = ' + inputName + ']').show();
                            isMsgSet = true;
                        } else {
                            angular.element('[error-for = ' + elem + '][paired-input = ' + inputName + ']').hide();
                        }
                    });

                    return text;
                }

                scope.$watchGroup([
                        function() {
                            return scope.getAdditionalErrorsDisplayCondition();
                        },
                        function() {
                            return ngModelCtrl.$viewValue;
                        },
                        '$parent.viewMngr.reqDataMngr.reqObj.typeOfService',
                        '$parent.viewMngr.reqDataMngr.reqObj.shipmentOption',
                        '$parent.viewMngr.helperDataMngr.helperObj.deliveryAddressOption',
                        '$parent.viewMngr.helperDataMngr.helperObj.isPickUpAddressDifferent'
                    ],
                    function() {
                        fromUser(null);
                    }
                );

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }

})()